import DatePicker from 'vue2-datepicker';

export default {
    name:'Datepicker',
    components: { DatePicker },
    data() {
        return {
            date:null,
            firstDate:'',
            lastDate:''
        };
    },
    methods: {
        handleChange() {
            this.firstDate = this.date[0].getFullYear() + '-' + (this.date[0].getMonth()<10?'0':'') + this.date[0].getMonth() +'-' + (this.date[0].getDate()<10?'0':'')+this.date[0].getDate()
            this.lastDate = this.date[1].getFullYear() + '-' + (this.date[1].getMonth()<10?'0':'') + this.date[1].getMonth() +'-'+ (this.date[0].getDate()<10?'0':'') +this.date[1].getDate()
        },
    }
};